export default __webpack_public_path__ + "assets/capturebagoniss.b26041a3.png";